// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.App-logo {
    width: auto;
    height: 56px;
    pointer-events: none;
    animation: fadeIn 0.5s linear forwards;
}

.App-header {
    background-color: #000000;
    padding: 16px 0;
    position: fixed;
    width: 100%;
    z-index: 4;
}

.App-header .container {
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-direction: row;
    flex-wrap: nowrap;
    padding: 0 32px;
}

.App-header ul {
    list-style: none;
    text-align: right;
    animation-delay: .25s;
    width: 100%;
}

.App-header ul li {
    display: inline-block;
    margin-left: 24px;
}

.App-header ul li a {
    text-transform: uppercase;
    color: white;
    opacity: 0;
    animation: fadeInLink 0.5s linear forwards;
    border: none;
    position: relative;
    text-decoration: none;
    width: fit-content;
    width: -moz-fit-content;
    display: inline-block;

    font-family: Montserrat;
    font-size: 12px;
    font-style: normal;
    font-weight: 700;
    line-height: 150%;
    letter-spacing: 1px;
    cursor: pointer;
}

.App-header button {
    background: transparent;
    z-index: 6;
    margin: 0;
    cursor: pointer;
}

.App-header button svg {
    display: block;
}

.header-spacer {
    width: 24px;
}

/* Menu */
.menu-overlay {
    background-color: #FFFFFF;
    width: 600px;
    height: 100%;
    position: absolute;
    right: 0;
    overflow: scroll;
}

.menu-overlay button {
    position: absolute;
    top: 32px;
    right: 32px;
}

.menu-container {
    padding: 80px 56px;
    text-align: left;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-end;
    gap: 56px;
}

.menu-tabs {
    width: 100%;
}

.menu-tabs-container {
    display: flex;
    gap: 24px;
    border-bottom: 1px solid #d8dce1;
    padding: 32px 0;
    background: white;
    position: sticky;
    top: 0;
}

.menu-tile-info {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 16px;
    padding: 32px 0;
    border-bottom: 1px solid #d8dce1;
}

.menu-description {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-end;
    gap: 16px;
}

.menu-description-links {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    gap: 16px;
}

.menu-description-links a {
    text-decoration: none;
}

.menu-tiles a {
    text-decoration: none;
}

.menu-description h3 {
    color: #000;
    font-family: Montserrat;
    font-size: 32px;
    font-style: normal;
    font-weight: 400;
    margin-bottom: 16px;
}

.menu-description h3 b {
    font-weight: 900;
}


@media screen and (max-width: 600px) {
    .menu-overlay {
        width: 100%;
    }
    .menu-description h3 {
        font-size: 28px;
    }
    
}

@media screen and (max-width: 448px) {
    .App-logo {
        height: 48px;
    }
}`, "",{"version":3,"sources":["webpack://./src/components/header/header.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,YAAY;IACZ,oBAAoB;IACpB,sCAAsC;AAC1C;;AAEA;IACI,yBAAyB;IACzB,eAAe;IACf,eAAe;IACf,WAAW;IACX,UAAU;AACd;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,mBAAmB;IACnB,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,qBAAqB;IACrB,WAAW;AACf;;AAEA;IACI,qBAAqB;IACrB,iBAAiB;AACrB;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,UAAU;IACV,0CAA0C;IAC1C,YAAY;IACZ,kBAAkB;IAClB,qBAAqB;IACrB,kBAAkB;IAClB,uBAAuB;IACvB,qBAAqB;;IAErB,uBAAuB;IACvB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,uBAAuB;IACvB,UAAU;IACV,SAAS;IACT,eAAe;AACnB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,WAAW;AACf;;AAEA,SAAS;AACT;IACI,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,QAAQ;IACR,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,yBAAyB;IACzB,SAAS;AACb;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,aAAa;IACb,SAAS;IACT,gCAAgC;IAChC,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,MAAM;AACV;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,SAAS;IACT,eAAe;IACf,gCAAgC;AACpC;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,yBAAyB;IACzB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,2BAA2B;IAC3B,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,WAAW;IACX,uBAAuB;IACvB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;AACpB;;;AAGA;IACI;QACI,WAAW;IACf;IACA;QACI,eAAe;IACnB;;AAEJ;;AAEA;IACI;QACI,YAAY;IAChB;AACJ","sourcesContent":[".App-logo {\n    width: auto;\n    height: 56px;\n    pointer-events: none;\n    animation: fadeIn 0.5s linear forwards;\n}\n\n.App-header {\n    background-color: #000000;\n    padding: 16px 0;\n    position: fixed;\n    width: 100%;\n    z-index: 4;\n}\n\n.App-header .container {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    flex-direction: row;\n    flex-wrap: nowrap;\n    padding: 0 32px;\n}\n\n.App-header ul {\n    list-style: none;\n    text-align: right;\n    animation-delay: .25s;\n    width: 100%;\n}\n\n.App-header ul li {\n    display: inline-block;\n    margin-left: 24px;\n}\n\n.App-header ul li a {\n    text-transform: uppercase;\n    color: white;\n    opacity: 0;\n    animation: fadeInLink 0.5s linear forwards;\n    border: none;\n    position: relative;\n    text-decoration: none;\n    width: fit-content;\n    width: -moz-fit-content;\n    display: inline-block;\n\n    font-family: Montserrat;\n    font-size: 12px;\n    font-style: normal;\n    font-weight: 700;\n    line-height: 150%;\n    letter-spacing: 1px;\n    cursor: pointer;\n}\n\n.App-header button {\n    background: transparent;\n    z-index: 6;\n    margin: 0;\n    cursor: pointer;\n}\n\n.App-header button svg {\n    display: block;\n}\n\n.header-spacer {\n    width: 24px;\n}\n\n/* Menu */\n.menu-overlay {\n    background-color: #FFFFFF;\n    width: 600px;\n    height: 100%;\n    position: absolute;\n    right: 0;\n    overflow: scroll;\n}\n\n.menu-overlay button {\n    position: absolute;\n    top: 32px;\n    right: 32px;\n}\n\n.menu-container {\n    padding: 80px 56px;\n    text-align: left;\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    justify-content: flex-end;\n    gap: 56px;\n}\n\n.menu-tabs {\n    width: 100%;\n}\n\n.menu-tabs-container {\n    display: flex;\n    gap: 24px;\n    border-bottom: 1px solid #d8dce1;\n    padding: 32px 0;\n    background: white;\n    position: sticky;\n    top: 0;\n}\n\n.menu-tile-info {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 16px;\n    padding: 32px 0;\n    border-bottom: 1px solid #d8dce1;\n}\n\n.menu-description {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    justify-content: flex-end;\n    gap: 16px;\n}\n\n.menu-description-links {\n    display: flex;\n    flex-direction: row;\n    justify-content: flex-start;\n    align-items: center;\n    gap: 16px;\n}\n\n.menu-description-links a {\n    text-decoration: none;\n}\n\n.menu-tiles a {\n    text-decoration: none;\n}\n\n.menu-description h3 {\n    color: #000;\n    font-family: Montserrat;\n    font-size: 32px;\n    font-style: normal;\n    font-weight: 400;\n    margin-bottom: 16px;\n}\n\n.menu-description h3 b {\n    font-weight: 900;\n}\n\n\n@media screen and (max-width: 600px) {\n    .menu-overlay {\n        width: 100%;\n    }\n    .menu-description h3 {\n        font-size: 28px;\n    }\n    \n}\n\n@media screen and (max-width: 448px) {\n    .App-logo {\n        height: 48px;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
